import { AnalyticMetricEnum } from '@laborability/commons';
import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(quarterOfYear);
dayjs.extend(isoWeek);

export enum DateAggregationEnum {
  day = 'day',
  week = 'week',
  month = 'month',
}

export const ANALYTIC_METRIC_LABEL: { [x: string]: string } = {
  [AnalyticMetricEnum.activeUsers]: 'Utenti attivi',
  [AnalyticMetricEnum.totalUsers]: 'Utenti totali',
  [AnalyticMetricEnum.sessions]: 'Sessioni',
  [AnalyticMetricEnum.averageSessionDuration]: 'Durata media sessioni',
  [AnalyticMetricEnum.activeUsersPercentage]: 'Percentuale utenti attivi',
  [AnalyticMetricEnum.averageSessionDurationPerUser]:
    'Percentuale durata media sessioni',
  [AnalyticMetricEnum.recurringUsers]: 'Utenti nuovi vs ricorrenti',
  [AnalyticMetricEnum.frequencyVisitsAgain]: 'Frequenza visite di ritorno',
  [AnalyticMetricEnum.newUsers]: 'Nuovi utenti',
  [AnalyticMetricEnum.sessionSourceMedium]: 'Fonte sessioni',
  [AnalyticMetricEnum.deviceCategory]: 'Dispositivo sessioni',
  [AnalyticMetricEnum.pagePerSession]: 'Pagine per sessione',
  [AnalyticMetricEnum.sessionsExcludingMeasureViews]:
    'Sessioni senza visualizzazioni di misure',
  [AnalyticMetricEnum.averageQuestionaryCompletionPercentage]:
    'Percentuale completamento questionario',
  [AnalyticMetricEnum.outlinkClicks]: 'Outlink da contenuto',
  [AnalyticMetricEnum.mostPopularCategories]: 'Categorie più popolari',
  [AnalyticMetricEnum.measureMaxUsersEligibility]: 'Misure più elette',
  [AnalyticMetricEnum.measuresWithNoEligibility]: 'Misure non elette',
  [AnalyticMetricEnum.averageMeasuresPerEligibleUser]:
    'Media misure eleggibili per utente',
  [AnalyticMetricEnum.mostViewed]: 'Bonus più visualizzati',
  [AnalyticMetricEnum.userEngagementDuration]:
    'Tempo medio sulla pagina misura',
};

export const TAB_PANORAMICA_METRICS = [
  AnalyticMetricEnum.activeUsers,
  AnalyticMetricEnum.activeUsersPercentage,
  AnalyticMetricEnum.sessions,
  AnalyticMetricEnum.averageSessionDuration,
  AnalyticMetricEnum.sessionSourceMedium,
  AnalyticMetricEnum.deviceCategory,
];
export const TAB_UTENTI_METRICS = [
  AnalyticMetricEnum.pagePerSession,
  AnalyticMetricEnum.newUsers,
  AnalyticMetricEnum.recurringUsers,
  AnalyticMetricEnum.sessionsExcludingMeasureViews,
  AnalyticMetricEnum.averageQuestionaryCompletionPercentage,
  AnalyticMetricEnum.averageSessionDurationPerUser,
  AnalyticMetricEnum.frequencyVisitsAgain,
];
export const TAB_CONTENUTO_METRICS = [
  AnalyticMetricEnum.mostViewed,
  AnalyticMetricEnum.userEngagementDuration,
  AnalyticMetricEnum.outlinkClicks,
  AnalyticMetricEnum.mostPopularCategories,
  AnalyticMetricEnum.measureMaxUsersEligibility,
  AnalyticMetricEnum.measuresWithNoEligibility,
  AnalyticMetricEnum.averageMeasuresPerEligibleUser,
];

export const TABS = [
  {
    id: 1,
    label: 'Panoramica',
    metrics: TAB_PANORAMICA_METRICS,
  },
  {
    id: 2,
    label: 'Utenti',
    metrics: TAB_UTENTI_METRICS,
  },
  {
    id: 3,
    label: 'Contenuto',
    metrics: TAB_CONTENUTO_METRICS,
  },
];

export enum viewTypeEnum {
  widget = 'widget',
  timeseries = 'timeseries',
}

export const VIEWS = [
  {
    id: 1,
    label: 'Widget',
    type: viewTypeEnum.widget,
  },
  {
    id: 2,
    label: 'Timeseries',
    type: viewTypeEnum.timeseries,
  },
];

export const PERIOD = [
  {
    id: 1,
    label: 'Questa settimana',
    value: {
      start: dayjs().startOf('isoWeek'),
      end: dayjs(),
    },
    isVisible: [DateAggregationEnum.day],
  },
  {
    id: 2,
    label: 'Scorsa settimana',
    value: {
      start: dayjs().subtract(1, 'week').startOf('isoWeek'),
      end: dayjs().subtract(1, 'week').endOf('isoWeek'),
    },
    isVisible: [DateAggregationEnum.day],
  },
  {
    id: 3,
    label: 'Questo mese',
    value: {
      start: dayjs().startOf('month'),
      end: dayjs(),
    },
    isVisible: [DateAggregationEnum.day, DateAggregationEnum.week],
  },
  {
    id: 4,
    label: 'Scorso mese',
    value: {
      start: dayjs().subtract(1, 'month').startOf('month'),
      end: dayjs().subtract(1, 'month').endOf('month'),
    },
    isVisible: [DateAggregationEnum.day, DateAggregationEnum.week],
  },
  {
    id: 5,
    label: 'Questo trimestre',
    value: {
      start: dayjs().startOf('quarter'),
      end: dayjs(),
    },
    isVisible: [
      DateAggregationEnum.day,
      DateAggregationEnum.week,
      DateAggregationEnum.month,
    ],
  },
  {
    id: 6,
    label: 'Scorso trimestre',
    value: {
      start: dayjs().subtract(1, 'quarter').startOf('quarter'),
      end: dayjs().subtract(1, 'quarter').endOf('quarter'),
    },
    isVisible: [
      DateAggregationEnum.day,
      DateAggregationEnum.week,
      DateAggregationEnum.month,
    ],
  },
  {
    id: 7,
    label: "Quest'anno",
    value: {
      start: dayjs().startOf('year'),
      end: dayjs(),
    },
    isVisible: [
      DateAggregationEnum.day,
      DateAggregationEnum.week,
      DateAggregationEnum.month,
    ],
  },
  {
    id: 8,
    label: 'Scorso anno',
    value: {
      start: dayjs().subtract(1, 'year').startOf('year'),
      end: dayjs().subtract(1, 'year').endOf('year'),
    },
    isVisible: [
      DateAggregationEnum.day,
      DateAggregationEnum.week,
      DateAggregationEnum.month,
    ],
  },
  {
    id: 9,
    label: 'Ultimi 7 giorni',
    value: {
      start: dayjs().subtract(7, 'days'),
      end: dayjs(),
    },
    isVisible: [DateAggregationEnum.day],
  },
  {
    id: 10,
    label: 'Ultimi 30 giorni',
    value: {
      start: dayjs().subtract(30, 'days'),
      end: dayjs(),
    },
    isVisible: [DateAggregationEnum.day, DateAggregationEnum.week],
  },
  {
    id: 11,
    label: "Dall'inizio",
    value: {
      start: dayjs('2024-01-01'),
      end: dayjs(),
    },
    isVisible: [
      DateAggregationEnum.day,
      DateAggregationEnum.week,
      DateAggregationEnum.month,
    ],
  },
];

export const COMPARISION_PERIOD = [
  {
    id: 1,
    label: 'Periodo precedente',
    getValue: (referenceStart: dayjs.Dayjs, referenceEnd: dayjs.Dayjs) => ({
      start: referenceStart.subtract(
        referenceEnd.diff(referenceStart, 'days') + 1,
        'days',
      ),
      end: referenceStart.subtract(1, 'days'),
    }),
    isVisible: [
      DateAggregationEnum.day,
      DateAggregationEnum.week,
      DateAggregationEnum.month,
    ],
  },
  {
    id: 2,
    label: 'Mese precedente',
    getValue: (referenceStart: dayjs.Dayjs, referenceEnd: dayjs.Dayjs) => ({
      start: referenceStart.subtract(30, 'days'),
      end: referenceStart
        .subtract(30, 'days')
        .add(referenceEnd.diff(referenceStart, 'days'), 'days'),
    }),
    isVisible: [DateAggregationEnum.day, DateAggregationEnum.week],
  },
  {
    id: 3,
    label: 'Trimestre precedente',
    getValue: (referenceStart: dayjs.Dayjs, referenceEnd: dayjs.Dayjs) => ({
      start: referenceStart.subtract(90, 'days'),
      end: referenceStart
        .subtract(90, 'days')
        .add(referenceEnd.diff(referenceStart, 'days'), 'days'),
    }),
    isVisible: [
      DateAggregationEnum.day,
      DateAggregationEnum.week,
      DateAggregationEnum.month,
    ],
  },
  {
    id: 4,
    label: 'Anno precedente',
    getValue: (referenceStart: dayjs.Dayjs, referenceEnd: dayjs.Dayjs) => ({
      start: referenceStart.subtract(365, 'days'),
      end: referenceStart
        .subtract(365, 'days')
        .add(referenceEnd.diff(referenceStart, 'days'), 'days'),
    }),
    isVisible: [
      DateAggregationEnum.day,
      DateAggregationEnum.week,
      DateAggregationEnum.month,
    ],
  },
];
